import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=458a0f21&scoped=true&"
import script from "./SalesDashboard.vue?vue&type=script&lang=js&"
export * from "./SalesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboard.vue?vue&type=style&index=0&id=458a0f21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a0f21",
  null
  
)

export default component.exports